module.exports = __webpack_public_path__ + "img/ch35.88c548d3.jpg";